export const extractOrderId = (url: string): number | undefined => {
  const match = url.match(/order\/(\d+)/);
  return match ? Number(match[1]) : undefined;
};
